import React from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

const CopyDialog = ({
  isOpen,
  onClose,
  selectedVariablesCount,
  loadingRepositories,
  repoSearchTerm,
  setRepoSearchTerm,
  targetRepositories = [],
  selectedTargetRepos = [],
  onToggleTargetRepo,
  onCopyVariables,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl max-h-[90vh]">
        <DialogHeader>
          <DialogTitle>Copy Variables to Repositories</DialogTitle>
          <DialogDescription>
            Select target repositories to copy {selectedVariablesCount}{" "}
            variable(s)
          </DialogDescription>
        </DialogHeader>
        {loadingRepositories ? (
          <div className="flex justify-center py-8">
            <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <>
            <div className="py-2">
              <Label htmlFor="repoSearch">Search repositories</Label>
              <Input
                id="repoSearch"
                placeholder="Search by name..."
                value={repoSearchTerm || ""}
                onChange={(e) => setRepoSearchTerm(e)}
                className="mt-1"
                autoComplete="off"
              />
            </div>
            <div className="max-h-[400px] overflow-y-auto pr-2">
              {Array.isArray(targetRepositories) &&
              targetRepositories.length > 0 ? (
                <div className="space-y-2 py-4">
                  {targetRepositories.map((repo) => (
                    <div
                      key={repo?.slug || Math.random()}
                      className="flex items-center space-x-3 bg-muted/30 hover:bg-muted/50 rounded px-3 py-2"
                    >
                      <div className="flex items-center justify-center">
                        <Checkbox
                          id={`repo-${repo?.slug}`}
                          checked={selectedTargetRepos.includes(repo?.slug)}
                          onCheckedChange={() =>
                            typeof onToggleTargetRepo === "function" &&
                            repo?.slug &&
                            onToggleTargetRepo(repo.slug)
                          }
                          className="data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground border-muted-foreground/30"
                        />
                      </div>
                      <Label
                        htmlFor={`repo-${repo?.slug}`}
                        className="flex-1 cursor-pointer"
                      >
                        <span className="font-medium">
                          {repo?.name || "Unnamed Repository"}
                        </span>
                        <span className="block text-xs text-muted-foreground">
                          {repo?.slug || "no-slug"}
                        </span>
                      </Label>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="py-8 text-center text-muted-foreground">
                  No other repositories available
                </div>
              )}
            </div>
          </>
        )}
        <DialogFooter className="sm:justify-between flex-row items-center mt-4">
          <div className="text-sm text-muted-foreground">
            {selectedTargetRepos.length} repositories selected
          </div>
          <div className="flex gap-2">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button
              onClick={onCopyVariables}
              disabled={
                !Array.isArray(selectedTargetRepos) ||
                selectedTargetRepos.length === 0
              }
            >
              Copy variables
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CopyDialog;
